import ShiftEnum from "./../../../shared/ShiftEnum.js";
import vSelect from 'vue-select';
import { ValidationMessage, FormLabel } from "../../../shared/components";

export default {
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    entry: {
      type: Object,
      default: null
    },
    reportHoles: {
      type: Array,
      default: () => []
    },
    projectId: {
      type: Number
    }
  },
  components: {
    vSelect,
    ValidationMessage,
    FormLabel
  },
  data () {
    return {
      model: {
        holeId: null,
        holeNumber: '',
        shift: ShiftEnum.Day
      },
      isPopupActive:this.$props.isActive,
      shifts: ShiftEnum.definition,
      showInactiveHoles: false,
      canCreateHole: false,
      filteredProjectHoles: [],
      lastSearchedHoles: [],
      hasFetchedProjectHoles: false,
      debounceTimeout: null
    }
  },
  mounted() {
    if (this.entry) {
      this.model = structuredClone(this.entry);
    }
    this.refreshCanCreateHole();
  },
  watch: {
    isActive(val) {
      this.isPopupActive = val;
      if (val) this.fetchProjectHolesOnce();
    },
    isPopupActive(val) {
      if (val === false) {
        this.closePopup();
      }
    },
    async entry(newVal) {
      if (newVal) this.model = structuredClone(newVal);
      else this.model = {};
      this.concatReportHolesAndLastSearchedHoles();
      this.refreshCanCreateHole();
    },
    async showInactiveHoles(val) {
      this.lastSearchedHoles = [...await this.findHoles(null, val)];
      this.concatReportHolesAndLastSearchedHoles();
      this.refreshCanCreateHole();
    }
  },
  computed: {
    initialHoleNumber() {
      if (this.entry === null) return '';
      return this.entry.holeNumber;
    },
    isHoleValid() {
      if (this.model === null) return false;
      return this.model.holeId !== null && this.model.holeId !== 0 && this.model.shift !== null;
    },
    holePromptTitle() {
      return this.isNew ? this.$t('Drilling.DrillEntries.AddDrillingEntry') : this.$t('Drilling.DrillEntries.EditDrillingEntry');
    },
    isNew() {
      if (this.model === null) return false;
      const holeIdPropExists = this.model.holeId !== null && this.model.holeId !== undefined;
      const isUnmappedStablilsation = holeIdPropExists && this.model.holeId === 0 && this.model.id && this.model.id > 0;
      if (isUnmappedStablilsation) return false;

      return this.model.stagingDrillingEntryId === 0 || (!this.model.stagingDrillingEntryId);
    }
  },
  methods: {
    submitHole() {
      const clonedModel = structuredClone(this.model);
      const hole = this.filteredProjectHoles.find(_ => _.holeId === clonedModel.holeId)
      return this.$refs.holePromptObserver.validate().then(() => {
        this.$emit('submit', clonedModel, hole);
      });
    },
    closePopup() {
      this.$emit('closePopup');
    },

    // TODO: Rename this
    createHoleInProject() {
      this.$emit("openHoleSideview", this.model.shift, true);
    },

    addHole() {
      this.$emit("openHoleSideview", this.model.shift);
    },
    /**
     * Triggered when the search text changes.
     *
     * @param search  {String}    Current search text
     * @param loading {Function}	Toggle loading class
     */
    fetchOptions (search, loading) {
      if (search.length < 2) {
        this.concatReportHolesAndLastSearchedHoles();
        return;
      }
      if (this.debounceTimeout) clearTimeout(this.debounceTimeout);
      this.debounceTimeout = setTimeout(async () => {
        loading(true);
        const holes = await this.findHoles(search, this.showInactiveHoles);
        this.lastSearchedHoles = [...holes];
        this.concatReportHolesAndLastSearchedHoles();
        this.debounceTimeout = null;
        loading(false);
      }, 350);
    },
    /**
     * Fills the dropdown the first time the popup is shown on a report that has no
     * hole linked to it yet, since there would be nothing else to list. Later
     * openings keep lastSearchedHoles, so the user gets back what their last
     * search returned instead of the whole project again.
     */
    async fetchProjectHolesOnce() {
      if (this.hasFetchedProjectHoles || this.reportHoles.length > 0) return;
      this.hasFetchedProjectHoles = true;
      this.lastSearchedHoles = [...await this.findHoles(null, true)];
      this.concatReportHolesAndLastSearchedHoles();
    },
    /**
     * Whether the report hole is missing from the project, which only the backend
     * can tell. Kept as state: as a computed it returned the promise itself (always
     * truthy) and re-queried the API on every re-render.
     */
    async refreshCanCreateHole() {
      if (!this.entry || !this.initialHoleNumber) {
        this.canCreateHole = false;
        return;
      }
      const holes = await this.findHoles(this.initialHoleNumber, this.showInactiveHoles);
      this.canCreateHole = holes.length === 0 && !this.isNew;
    },
    async findHoles(holeCode, includeInactiveHoles) {
      const mainProjectId = Number(this.$store.state.projectId);
      const reponses = await this.$cqrsGet("Drilling/Holes/Search", { params: { mainProjectId, projectId: this.projectId, holeCode, includeInactiveHoles }});
      return reponses.data.model.sort((a, b) => a.code.localeCompare(b.code));
    },
    concatReportHolesAndLastSearchedHoles() {
      const combined = this.reportHoles.concat(this.lastSearchedHoles);
      const uniqueHoles = Array.from(new Map(combined.map(h => [h.code, h])).values());
      this.filteredProjectHoles = uniqueHoles;
    }
  },
  emits: ['submit', 'closePopup', 'openHoleSideview']
}
